import { client } from "@/api/client";
import interceptors from "@/api/interceptor";
import qs from "qs";

client.interceptors.request.use(interceptors.noAuth, interceptors.onError);

function login(username, password) {
  return client.post("auth/login", qs.stringify({ platform: "marketplace", username, password }), {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    }
  });
}

function loginJwt(token) {
  return client.post("auth/login/login-jwt", qs.stringify({ platform: "marketplace", token }), {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    }
  });
}

function loginsso(params) {
  return client.post("public/auth/login-sso", qs.stringify(params), {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    }
  });
}

function register(params) {
  return client.post("registration/submit", qs.stringify(params), {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    }
  });
}

function forgetPassword(mobilephone, email) {
  return client.post(
    "auth/login/forget-password",
    qs.stringify({ platform: "marketplace", mobilephone, email }),
    {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded"
      }
    }
  );
}

function confirmNewPassword(token, password, repassword) {
  return client.post(
    "auth/login/confirm-new-password",
    qs.stringify({ platform: "marketplace", token, password, repassword }),
    {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded"
      }
    }
  );
}

function verifyToken(token) {
  return client.post("auth/login/verify_token_new_password", qs.stringify({ token }), {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    }
  });
}

export default {
  login,
  loginJwt,
  loginsso,
  register,
  forgetPassword,
  confirmNewPassword,
  verifyToken
};
